import {colors} from 'shells/colors/colors';
import {Stack} from 'shells/layout/stack/stack';
import {ProgressBar} from 'shells/progress-bar/progress-bar';
import {Body} from 'shells/typography/body';

interface Props {
    used: number;
    limit: number;
}

/**
 * Get the label for the reset date (The 1st of next month)
 */
const getResetLabel = () => {
    const resetDate = new Date();
    resetDate.setMonth(resetDate.getMonth() + 1, 1);
    return resetDate.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
};

export function UsageProgress(props: Props) {
    const remaining = Math.max(props.limit - props.used, 0);
    const percentUsed = props.limit > 0 ? Math.min(props.used / props.limit, 1) : 0;

    return (
        <Stack spacing={12}>
            <ProgressBar
                percentComplete={percentUsed}
                height={6}
                roundedCorners={true}
                showPercentage={true}
                backgroundColor={colors.aiPurplePinkLt}
                color={colors.aiPurpleLt}
            />
            <Stack isHorizontal={true} justifyContent='space-between' isFullWidth={true}>
                <Body color='light' size='tiny'>
                    {remaining.toLocaleString()} remaining
                </Body>
                <Body color='light' size='tiny'>
                    Resets {getResetLabel()}
                </Body>
            </Stack>
        </Stack>
    );
}
